export default function ($translate) {
    return {
        KEYS: {
            NOTIFICATION_NOT_SENT: 'NOTIFICATION_NOT_SENT',
            NOT_STARTED: 'NOT_STARTED',
            NOT_COMPLETED: 'NOT_COMPLETED',
            COMPLETED: 'COMPLETED',
            DELETED: 'DELETED'
        },
        LABELS: {
            NOTIFICATION_NOT_SENT: $translate.instant('survey.Notification not sent'),
            NOT_STARTED: $translate.instant('survey.Not started'),
            NOT_COMPLETED: $translate.instant('survey.Not completed'),
            COMPLETED: $translate.instant('survey.Completed'),
            DELETED: $translate.instant('survey.Deleted')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/survey/participant/status/index.js